var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 6 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.823.853v1.225c0 .205-.248.306-.392.162l-.342-.342L2.76 4.23c-.09.09-.235.09-.325 0l-.216-.216c-.09-.09-.09-.236 0-.325l2.33-2.331-.342-.342C4.062.871 4.164.623 4.37.623h1.224c.127 0 .23.103.23.23zM4.206 3.215l-.153.153c-.043.043-.067.102-.067.162v1.38H.924V1.849H3.45c.06 0 .12-.024.162-.067l.153-.153c.145-.145.043-.392-.162-.392H.771c-.254 0-.46.205-.46.459v3.37c0 .253.206.458.46.458h3.368c.254 0 .46-.205.46-.459V3.377c0-.204-.248-.307-.393-.162z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.c06b718bc0b42a8e5d7460b8bf31681f.svg";
export { ForwardRef as ReactComponent };